var React = require('react');

function N31 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("path",{"d":"M194.19,308.85,214,287a29.46,29.46,0,0,1-39.52,43.71Z","transform":"translate(-173.4 -257.58)","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"43.69 32.05 49.53 13.6 28.78 7.03 6.57 0 0 20.75 22.21 27.78 15.18 49.99 23.32 52.57 43.69 32.05","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

N31.defaultProps = {"viewBox":"0 0 50.25 80.73"};

module.exports = N31;

N31.default = N31;
